import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useFirebase } from '../context/firebaseContext';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { PlatformContext } from '../context/PlatformContext';
import RegisterMobile from '../mobile/components/RegisterMobile';

const Register = () => {
    const { platform, loading } = useContext(PlatformContext);
    const { auth, db } = useFirebase();
    const navigate = useNavigate();
    const [userRegistration, setUserRegistration] = useState({
        email: '',
        password: '',
        confirmPassword: '',
        username: '',
    });
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);

    useEffect(() => {
        const successMessageTimeout = setTimeout(() => {
            setSuccessMessage(null);
        }, 3000);

        return () => clearTimeout(successMessageTimeout);
    }, [successMessage]);

    const handleChange = (e) => {
        const { name, value } = e.currentTarget;
        setUserRegistration({
            ...userRegistration,
            [name]: value,
        });
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        const { email, password, confirmPassword, username } = userRegistration;

        if (password !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        try {
            setError(null);

            // Register the user using Firebase Authentication
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            // Write the username to Firestore
            const userDocRef = doc(db, 'users', user.uid);
            await setDoc(userDocRef, { username, email });

            setSuccessMessage('Registration successful! Redirecting to login...');
            setTimeout(() => navigate('/login'), 2000);
        } catch (error) {
            console.error('Registration error:', error.message);
            setError('Registration failed. Please try again.');
        }
    };

    // Show mobile register on mobile platforms
    if (!loading && (platform === 'mobileApp' || platform === 'mobileWeb')) {
        return <RegisterMobile />;
    }

    // Show desktop register on desktop platforms
    return (
        <section className="hero is-dark-grey has-text-centered auth-hero">
            <div className="hero-body">
                <div className="container">
                    <div className="columns is-centered">
                        <div className="column">
                            <form onSubmit={handleRegister} className="box lightning-border" style={{
                                maxWidth: '800px',
                                maxHeight: '90vh',
                                margin: '0 auto',
                                padding: '2.5rem',
                                borderRadius: '12px',
                                background: 'linear-gradient(135deg, rgba(119, 44, 56, 0.95), rgba(119, 44, 56, 0.85))',
                                boxShadow: '0 10px 30px rgba(255, 215, 0, 0.08), 0 4px 12px rgba(0, 0, 0, 0.18)'
                            }}>
                                <div className="has-text-centered" style={{ marginBottom: '2.5rem' }}>
                                    <h1 className="title" style={{
                                        color: '#FFA500',
                                        letterSpacing: '0.05em',
                                        textShadow: '0 2px 8px rgba(255, 165, 0, 0.4)',
                                        marginBottom: '1.5rem',
                                        fontWeight: 700
                                    }}>
                                        Create Account
                                    </h1>
                                </div>

                                <div style={{ display: 'flex', gap: '1.5rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
                                    <div style={{ flex: 1, minWidth: '220px' }}>
                                        <label htmlFor="username" className="label has-text-warning">Username</label>
                                        <div className="control">
                                            <input
                                                className="input"
                                                type="text"
                                                id="username"
                                                name="username"
                                                value={userRegistration.username}
                                                onChange={handleChange}
                                                required
                                                style={{
                                                    border: '1px solid rgba(255, 215, 0, 0.3)',
                                                    borderRadius: '8px',
                                                    transition: 'all 0.3s ease',
                                                    background: 'rgba(255, 255, 255, 0.05)',
                                                    backdropFilter: 'blur(10px)'
                                                }}
                                                onFocus={e => {
                                                    e.target.style.borderColor = '#FFD700';
                                                    e.target.style.boxShadow = '0 0 0 2px rgba(255, 215, 0, 0.2)';
                                                }}
                                                onBlur={e => {
                                                    e.target.style.borderColor = 'rgba(255, 215, 0, 0.3)';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div style={{ flex: 1, minWidth: '220px' }}>
                                        <label htmlFor="email" className="label has-text-warning">Email</label>
                                        <div className="control">
                                            <input
                                                className="input has-text-warning"
                                                type="email"
                                                id="email"
                                                name="email"
                                                value={userRegistration.email}
                                                onChange={handleChange}
                                                required
                                                style={{
                                                    border: '1px solid rgba(255, 215, 0, 0.3)',
                                                    borderRadius: '8px',
                                                    transition: 'all 0.3s ease',
                                                    background: 'rgba(255, 255, 255, 0.05)',
                                                    backdropFilter: 'blur(10px)'
                                                }}
                                                onFocus={e => {
                                                    e.target.style.borderColor = '#FFD700';
                                                    e.target.style.boxShadow = '0 0 0 2px rgba(255, 215, 0, 0.2)';
                                                }}
                                                onBlur={e => {
                                                    e.target.style.borderColor = 'rgba(255, 215, 0, 0.3)';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: '1.5rem', marginBottom: '2rem', flexWrap: 'wrap' }}>
                                    <div style={{ flex: 1, minWidth: '220px' }}>
                                        <label htmlFor="password" className="label has-text-warning">Password</label>
                                        <div className="control">
                                            <input
                                                className="input"
                                                type="password"
                                                id="password"
                                                name="password"
                                                value={userRegistration.password}
                                                onChange={handleChange}
                                                required
                                                style={{
                                                    border: '1px solid rgba(255, 215, 0, 0.3)',
                                                    borderRadius: '8px',
                                                    transition: 'all 0.3s ease',
                                                    background: 'rgba(255, 255, 255, 0.05)',
                                                    backdropFilter: 'blur(10px)'
                                                }}
                                                onFocus={e => {
                                                    e.target.style.borderColor = '#FFD700';
                                                    e.target.style.boxShadow = '0 0 0 2px rgba(255, 215, 0, 0.2)';
                                                }}
                                                onBlur={e => {
                                                    e.target.style.borderColor = 'rgba(255, 215, 0, 0.3)';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div style={{ flex: 1, minWidth: '220px' }}>
                                        <label htmlFor="confirmPassword" className="label has-text-warning">Confirm Password</label>
                                        <div className="control">
                                            <input
                                                className="input"
                                                type="password"
                                                id="confirmPassword"
                                                name="confirmPassword"
                                                value={userRegistration.confirmPassword}
                                                onChange={handleChange}
                                                required
                                                style={{
                                                    border: '1px solid rgba(255, 215, 0, 0.3)',
                                                    borderRadius: '8px',
                                                    transition: 'all 0.3s ease',
                                                    background: 'rgba(255, 255, 255, 0.05)',
                                                    backdropFilter: 'blur(10px)'
                                                }}
                                                onFocus={e => {
                                                    e.target.style.borderColor = '#FFD700';
                                                    e.target.style.boxShadow = '0 0 0 2px rgba(255, 215, 0, 0.2)';
                                                }}
                                                onBlur={e => {
                                                    e.target.style.borderColor = 'rgba(255, 215, 0, 0.3)';
                                                    e.target.style.boxShadow = 'none';
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {error && (
                                    <div className="notification is-danger is-light mb-4" style={{
                                        background: 'rgba(255, 0, 0, 0.1)',
                                        border: '1px solid rgba(255, 0, 0, 0.3)',
                                        color: '#ff6b6b',
                                        borderRadius: '8px'
                                    }}>
                                        {error}
                                    </div>
                                )}

                                {successMessage && (
                                    <div className="notification is-success is-light mb-4" style={{
                                        background: 'rgba(0, 255, 0, 0.1)',
                                        border: '1px solid rgba(0, 255, 0, 0.3)',
                                        color: '#4CAF50',
                                        borderRadius: '8px'
                                    }}>
                                        {successMessage}
                                    </div>
                                )}

                                <div className="field">
                                    <div className="control">
                                        <button
                                            type="submit"
                                            className="button is-warning is-fullwidth"
                                            style={{
                                                background: 'linear-gradient(135deg, #FFD700, #FFA500)',
                                                border: 'none',
                                                borderRadius: '8px',
                                                padding: '0.75rem 1.5rem',
                                                fontSize: '1rem',
                                                fontWeight: '600',
                                                transition: 'all 0.3s ease',
                                                boxShadow: '0 4px 15px rgba(255, 215, 0, 0.3)',
                                                color: '#1a1a2e'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.transform = 'translateY(-2px)';
                                                e.target.style.boxShadow = '0 6px 20px rgba(255, 215, 0, 0.4)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.transform = 'translateY(0)';
                                                e.target.style.boxShadow = '0 4px 15px rgba(255, 215, 0, 0.3)';
                                            }}
                                        >
                                            Create Account
                                        </button>
                                    </div>
                                </div>

                                <div className="has-text-centered mt-4">
                                    <p className="has-text-warning" style={{ fontSize: '0.9rem' }}>
                                        Already have an account?{' '}
                                        <Link to="/login" style={{ color: '#FFA500', textDecoration: 'underline' }}>
                                            Sign in here
                                        </Link>
                                    </p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Register;
